const translation = {
  "all_rights_reserved": "Todos los derechos reservados",
  "procedures": "Procedimientos",
  "laboratories": "Laboratorios",
  "radiology": "Radiología",
  "consultation": "Consulta",
  "medical_consumables": "Consumibles Médicos",
  "medical_equipments": "Equipos Médicos",
  "sanitation_disinfection": "Saneamiento y Desinfección",
  "medical_equipment": "Equipo Médico",
  "procedure": "Procedimiento",
  "Disinfection": "Desinfección",
  "lab_supplies": "Suministros de laboratorio",
  "pharmacy_items": "Artículos de farmacia",
  "home": "Inicio",
  "dashboard": "Panel de Control",
  "services": "Servicios",
  "products": "Productos",
  "contact": "Contacto",
  "login": "Iniciar Sesión",
  "loginNow": "Iniciar Sesión Ahora",
  "findMyDoctor": "Encontrar Mi Doctor",
  "registerAsVendor": "Registrarse como Proveedor",
  "searchPlaceholder": "Buscar productos, servicios...",
  "welcomeMessage": "Bienvenido a Aryal Care",
  "currentLanguage": "Idioma Actual",
  "phone": "Teléfono",
  "email": "Correo electrónico",
  "address": "Dirección",
  "website": "Sitio Web",
  "information": "Información",
  "aboutUs": "Sobre Nosotros",
  "contactUs": "Contáctenos",
  "privacyPolicy": "Política de Privacidad",
  "terms": "Términos y Condiciones ",
  "deliveryInfo": "Información de Envíos",
  "ordersReturns": "Pedidos y Devoluciones",
  "customerCare": "Atención al Cliente",
  "help": "Ayuda y Preguntas Frecuentes",
  "myAccount": "Mi Cuenta",
  "orderHistory": "Historial de Pedidos",
  "wishlist": "Lista de Deseos",
  "newsletter": "Boletín de Noticias",
  "purchasingPolicy": "Política de Compra",
  "newsletterText": "Suscríbase a nuestra lista de correo para recibir las últimas actualizaciones y ofertas.",
  "enterEmail": "Ingrese su dirección de correo",
  "subscribeNow": "Suscríbase Ahora",
  "copyright": "Derechos de autor",
  "freeShipping": "Envío Gratis",
  "freeShippingText": "Envío gratis a todo el mundo",
  "support24_7": "Soporte 24/7",
  "support24_7Text": "Contáctenos las 24 horas del día",
  "securePayments": "Pagos Seguros",
  "securePaymentsText": "Protección de pago 100%",
  "easyReturn": "Devolución Fácil",
  "easyReturnText": "Política de devoluciones simple",
  "title": "Categorías",
  "scan": "Escaneo",
  "laboratory": "Laboratorio",
  "miscellaneous": "Misceláneos",
  "consumables": "Consumibles",
  "pharmacy": "Farmacia",
  "itemsFor": "Artículos de {category}",
  "categoryContent": "Contenido para la categoría {category} aparecería aquí.",
  "shopNow": "Comprar ahora",
  "yes": "Sí",
  "no": "No",
  "ok": "Ok",
  "cancel": "Cancelar",
  "logout": "Cerrar sesión",
  "logoutConfirmMessage": "¿Está seguro de que desea cerrar sesión?",
  "confirm": "Confirmar",
  "step": "Paso",
  "banners": {
    "title": "Banners",
    "web_banners": "Banners Web",
    "app_banners": "Banner de la app",
    "Hero Banner": "Banner Principal",
    "hero_banner": "Banner Principal",
    "hero_small_top": "Banner Principal Pequeño Superior",
    "hero_small_bottom": "Banner Principal Pequeño Inferior",
    "deals_banner": "Banner de Ofertas",
    "banner1": "Banner 1",
    "banner2": "Banner 2",
    "health_tip": "Consejo de Salud",
    "hero_banner_bottom": "Banner Principal Inferior",
    "product_hero_banner": "Banner Principal de Producto",
    "middle_banner": "Banner Medio",
    "middle_small_banner": "Banner Medio Pequeño",
    "lower_midline_banner": "Banner de Línea Media Inferior",
    "Hero Banner Top": "Banner Principal Superior",
    "Health Tip": "Consejo de Salud",
    "Hero Banner Product": "Banner Principal de Producto",
    "Primary banner": "Banner Principal",
    "Secondary Banner": "Banner Secundario",
    "Tertiary Banner": "Banner Terciario",
    "Hero banner Top": "Banner Principal Superior",
    "Health Banner": "Banner de Salud",
    "Hero Banner Bottom": "Banner Principal Inferior",
    "Product Banner": "Banner de Producto",
    "update": "Actualizar",
    "ID": "ID",
    "Title": "Título",
    "Screen type": "Tipo de Pantalla",
    "Width": "Ancho",
    "Height": "Altura",
    "Price": "Precio",
    "noBannerData": "No se encontraron datos de banner.",
    "invalidImageFile": "Archivo de imagen inválido.",
    "pleaseSelectImage": "Por favor seleccione un archivo de imagen.",
    "failedToUpdate": "Error al actualizar la imagen del banner.",
    "updateBannerImage": "Actualizar Imagen del Banner",
    "chooseNewImage": "Elegir Nueva Imagen",
    "requiredSize": "Tamaño requerido: {{width}}x{{height}}px, Máx {{maxSize}}MB",
    "uploading": "Subiendo...",
    "updateImage": "Actualizar Imagen",
    "chooseFile": "Elegir Archivo",
    "noFileChosen": "Ningún archivo elegido",
    "updatedSuccessfully": "Banner actualizado exitosamente",
    "invalidDimensions": "Las dimensiones de la imagen deben ser {{width}}x{{height}}px"
  },
  "loginPage": {
    "subtitle": "Acceda a su panel de proveedor para gestionar sus servicios de salud.",
    "username": "Nombre de usuario",
    "usernamePlaceholder": "Ingrese su nombre de usuario",
    "password": "Contraseña",
    "passwordPlaceholder": "Ingrese su contraseña",
    "forgotPassword": "¿Olvidó su contraseña?",
    "loginButton": "Iniciar Sesión",
    "loggingIn": "Iniciando sesión...",
    "loginFailed": "Error al iniciar sesión",
    "errorMessages": {
      "invalidCredentials": "Usuario o contraseña incorrectos",
      "invalidUser": "Tipo de usuario inválido ",
      "serverError": "Error del servidor, por favor intente nuevamente más tarde",
      "networkError": "Error de red, por favor verifique su conexión",
      "required": "Por favor complete este campo"
    }
  },
  "vendorRegistration": {
    "idCard": {
      "idcard_type": "Tipo de Documento de Identidad",
      "idcard_no": "Número de Documento de Identidad",
      "enter_number": "Ingrese el número de documento",
      "dni_description": "Ingrese número de DNI de 8 dígitos",
      "ce": "Carné de Extranjería",
      "ce_description": "Ingrese número de carné de extranjería de 12 dígitos",
      "cf_description": "Ingrese número de cédula física (9 dígitos)",
      "cj_description": "Ingrese número de cédula jurídica (10 dígitos)",
      "dimex_description": "Ingrese número DIMEX (11-12 dígitos)",
      "nite_description": "Ingrese número NITE (10 dígitos)",
      "pe_description": "Ingrese número PE",
      "cof_description": "Ingrese número COF"
    },
    "title": "Registro de Proveedor",
    "headers": {
      "step1": "Registrarse como Proveedor",
      "step2": "Tipo de Proveedor",
      "step3": "Detalles del Proveedor",
      "step4": "Dirección",
      "step5": "Detalles de Cuenta",
      "step6": "Selecciona el plan de suscripción",
      "step7": "Vista Previa y Envío"
    },
    "descriptions": {
      "step1": "Complete el formulario para registrarse como Proveedor. Estamos emocionados de incluir su experiencia en nuestra red de salud digital.",
      "step2": "¿Listo para conectarse con clínicas y hospitales digitalmente? Regístrese ahora para mostrar sus servicios al público adecuado.",
      "step3": "Proporcione detalles sobre su organización o práctica médica.",
      "step4": "Indíquenos dónde operan sus servicios. Nos aseguraremos de que las conexiones adecuadas lleguen a usted.",
      "step5": "Proporcione información bancaria para transacciones.",
      "step6": "Términos e información. Al elegir una suscripción, aceptas los términos de uso del servicio",
      "step7": "Revise toda la información antes de enviar su registro."
    },
    "subdescriptions": {
      "step1": "Complete los detalles de registro.",
      "step2": "Por favor, seleccione el servicio en el que está interesado.",
      "step3": "Complete los detalles del proveedor.",
      "step4": "Ingrese los detalles del proveedor a continuación para completar su registro.",
      "step5": "Complete los detalles de la cuenta.",
      "step7": "Revise toda la información antes de enviar su registro."
    },
    "formLabels": {
      "name": "Nombre de la Organización",
      "adminName": "Nombre del Administrador",
      "userName": "Nombre de Usuario",
      "email": "Correo Electrónico",
      "phone": "Teléfono",
      "emergencyPhone": "Teléfono de Emergencia",
      "password": "Contraseña",
      "confirmPassword": "Confirmar Contraseña",
      "vendorType": "Tipo de Proveedor",
      "otherProfessional": "Otra Profesión",
      "accreditation": "Acreditación",
      "regNumber": "Número de Registro",
      "deliveryRadius": "Radio de Entrega (km)",
      "website": "Sitio Web",
      "establishedYear": "Año de Establecimiento",
      "gst": "GST",
      "vat": "IVA",
      "street": "Calle",
      "city": "Ciudad",
      "country": "País",
      "region": "Estado/Provincia",
      "zip": "Código Postal",
      "accountName": "Nombre de la Cuenta",
      "bankName": "Nombre del Banco",
      "iban": "IBAN",
      "nid": "Número de Identificación",
      "accountAddress": "Dirección de la Cuenta",
      "accountPhone": "Teléfono de la Cuenta",
      "singleUser": "único usuario"
    },
    "account": {
      "accountHolder": "Nombre del titular de la cuenta",
      "bankName": "Nombre del banco",
      "iban": "Número de cuenta / IBAN",
      "swift": "Código SWIFT/BIC",
      "branchAddress": "Dirección de la sucursal",
      "paymentMethod": "Método de pago",
      "currency": "Seleccione su moneda",
      "uploadProof": "Suba una prueba de cuenta",
      "uploadFile": "Subir archivo"
    },
    "common": {
      "selectOption": "Por favor seleccione",
      "submitted_successfully": "Registro enviado exitosamente"
    },
    "placeholders": {
      "name": "Ingrese el nombre de la organización",
      "adminName": "Ingrese el nombre del administrador",
      "userName": "Ingrese el nombre de usuario",
      "email": "Ingrese el correo electrónico",
      "phone": "Ingrese el número de teléfono",
      "emergencyPhone": "Ingrese el teléfono de emergencia",
      "password": "Ingrese la contraseña",
      "confirmPassword": "Confirme la contraseña",
      "accreditation": "Ingrese la acreditación",
      "regNumber": "Ingrese el número de registro",
      "deliveryRadius": "Ingrese el radio de entrega",
      "website": "Ingrese la URL del sitio web",
      "establishedYear": "Ingrese el año de establecimiento",
      "gst": "Ingrese el IVA",
      "street": "Ingrese la dirección",
      "city": "Ingrese la ciudad",
      "country": "Seleccione el país",
      "region": "Ingrese el estado/región",
      "zip": "Ingrese el código postal",
      "accountName": "Ingrese el nombre de la cuenta",
      "bankName": "Ingrese el nombre del banco",
      "iban": "Ingrese el IBAN",
      "nid": "Ingrese el número de identificación",
      "accountAddress": "Ingrese la dirección de la cuenta",
      "accountPhone": "Ingrese el teléfono de la cuenta"
    },
    "errors": {
      "submissionFailed": "Ocurrió un error inesperado. Por favor, intente nuevamente.",
      "idCardAlreadyExists": "Los detalles de la tarjeta de identificación ya están registrados",
      "idCardStartsWithZero": "El número de identificación no puede comenzar con 0",
      "invalidIdCardLength": "La longitud del número de identificación no es válida",
      "invalidIdCardPattern": "El formato del número de identificación no es válido",
      "invalidIdCard": "Número de identificación inválido",
      "idCardType": "Por favor seleccione el tipo de documento",
      "idCardNo": "Por favor ingrese un número de documento válido",
      "invalidIdCard": "Formato de documento de identidad inválido",
      "minLength": "Debe tener al menos 3 caracteres",
      "required": "Este campo es requerido",
      "invalidEmail": "Correo electrónico inválido",
      "passwordLength": "La contraseña debe tener al menos 8 caracteres",
      "passwordMismatch": "Las contraseñas no coinciden",
      "invalidPhone": "Número de teléfono inválido",
      "invalidWebsite": "URL del sitio web inválida (incluya http:// o https://)",
      "invalidYear": "Ingrese un año válido (1800-actual)",
      "invalidGST": "GST inválido",
      "invalidZip": "Código postal inválido",
      "passwordComplexity": "La contraseña debe contener entre 8 y 30 caracteres, una letra minúscula, una mayúscula, un número y un carácter especial",
      "This name is already registered": "Este nombre ya está registrado",
      "This phone is already registered": "Este teléfono ya está registrado",
      "This email is already registered": "Este correo electrónico ya está registrado",
      "This accreditation is already registered": "Esta acreditación ya está registrada",
      "This reg_number is already registered": "Este número de registro ya está registrado",
      "This user_name is already registered": "Este usuario ya está registrado",
      "invalidFileType": "Solo se permiten imágenes (JPG/PNG) y archivos PDF."
    },
    "buttons": {
      "previous": "Paso Anterior",
      "next": "Siguiente Paso",
      "submit": "Enviar Registro",
      "goBack": "Regresar"
    },
    "success": {
      "title": "Registro Exitoso",
      "message": "Su registro como proveedor ha sido recibido y está siendo revisado. Nuestro equipo verificará sus detalles y aprobará su solicitud pronto. Recibirá una notificación por correo electrónico una vez que su registro sea aprobado."
    },
    "vendorTypes": {
      "hospital": "Hospital",
      "clinic": "Clínica",
      "laboratory": "Laboratorio",
      "pharmacy": "Farmacia",
      "diagnostic": "Centro de Diagnóstico",
      "singleDoctor": "Médico individual",
      "singleNurse": "Enfermera individual",
      "other": "Otros profesionales"
    },
    "disclaimer": {
      "vatApplicable": "** Se aplica 13% de IVA en todos los planes de pago"
    },
    "subscriptionTypes": {
      "Basic": "Básico",
      "Free": "Plan Gratis",
      "monthly": " Mensual",
      "yearly": " Anual"
    },
    "selectProfession": "Seleccione su profesión",
    "selectProfessionPlaceholder": "Por favor seleccione",
    "bankingInfo": {
      "accountHolder": "Nombre del titular de la cuenta",
      "bankName": "Nombre del banco",
      "accountNumber": "Número de cuenta / IBAN",
      "swiftCode": "Código SWIFT/BIC",
      "branchAddress": "Dirección de la sucursal",
      "paymentMethod": "Método de pago",
      "currency": "Moneda",
      "proofDocument": "Documento de prueba",
      "subscriptionPlan": "Plan de suscripción"
    }
  },
  "previewDetails": {
    "sections": {
      "registration": "Detalles de registro",
      "vendorDetails": "Tipo y detalles del proveedor",
      "address": "Dirección",
      "transaction": "Detalles de transacción",
      "subscription": "Suscripción"
    },
    "labels": {
      "close": "Cerrar",
      "download": "Descargar",
      "idCardType": "Tipo de Documento",
      "idCardNumber": "Número de Documento",
      "notProvided": "No proporcionado",
      "name": "Nombre",
      "email": "Correo electrónico",
      "phone": "Número de teléfono",
      "emergencyPhone": "Número de emergencia",
      "password": "Contraseña",
      "vendorType": "Tipo de proveedor",
      "accreditation": "Acreditación",
      "registerNumber": "Número de registro",
      "deliveryRadius": "Radio de entrega",
      "website": "Enlace del sitio web",
      "establishedYear": "Año de establecimiento",
      "gst": "GST",
      "vat": "IVA",
      "street": "Nombre de la calle",
      "city": "Ciudad",
      "country": "País",
      "region": "Región",
      "zip": "Código postal",
      "accountHolder": "Nombre del titular de la cuenta",
      "bankName": "Nombre del banco",
      "accountNumber": "Número de cuenta",
      "swiftCode": "Código SWIFT/BIC",
      "branchAddress": "Dirección de la sucursal",
      "paymentMethod": "Método de pago",
      "currency": "Moneda",
      "proofDocument": "Documento de prueba",
      "cannotPreviewFile": "Este tipo de archivo no se puede previsualizar."
    },
    "errors": {
      "popupBlocked": "El popup fue bloqueado. Por favor, permite los popups en este sitio para ver los archivos."
    }
  },
  "registrationSuccess": {
    "title": "Registro Enviado Exitosamente",
    "successImageAlt": "Ícono de éxito",
    "message1": "Gracias por registrarse como proveedor en nuestra plataforma.",
    "message2": "Su registro ha sido recibido y está siendo revisado. Nuestro equipo verificará sus detalles y aprobará su solicitud pronto. Recibirá una notificación por correo electrónico una vez que su registro sea aprobado.",
    "message3": "Si tiene alguna consulta urgente, no dude en contactar a nuestro equipo de soporte.",
    "returnButton": "Volver al Inicio"
  },
  "dashboardMenu": {
    "vendors": "Proveedores",
    "catalogues": "Catálogos",
    "banners": "Banners",
    "revenue": "Ingresos",
    "liabilities": "Pasivos",
    "vendorLiabilities": "Pasivos de Proveedores",
    "patientLiabilities": "Pasivos de Pacientes"
  },
  "registeredHospitals": {
    "vendors": "Proveedores",
    "pending": "Pendiente",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "searchClinic": "Buscar clínica",
    "searchID": "Buscar ID",
    "searchLocation": "Buscar ubicación",
    "all": "Todos",
    "modernMedicine": "Medicina Moderna",
    "ayurveda": "Ayurveda",
    "homeopathy": "Homeopatía",
    "unani": "Unani",
    "dental": "Odontología",
    "multispeciality": "Multiespecialidad",
    "other": "Otro",
    "id": "ID",
    "clinic": "Proveedores",
    "patients": "Pacientes",
    "category": "Categoría",
    "type": "Tipo de Proveedor",
    "date": "Fecha",
    "location": "Ubicación",
    "noMoreApproved": "¡¡No hay más lista aprobada para mostrar!!",
    "noMorePending": "¡¡No hay más lista pendiente para mostrar!!",
    "noMoreRejected": "¡¡No hay más lista rechazada para mostrar!!",
    "noMoreExpired": "¡¡No hay más lista expirada para mostrar!!"
  },
  "common": {
    "ok": "Aceptar",
    "yes": "Sí",
    "no": "No",
    "notAvailable": "No Disponible"
  },
  "hospitalDetails": {
    "navigation": {
      "home": "Inicio",
      "bankingInfo": "Información Bancaria",
      "reports": "Reportes",
      "liabilities": "Pasivos"
    },
    "buttons": {
      "vendors": "Proveedores",
      "approve": "Aprobar",
      "reject": "Rechazar",
      "delete": "Eliminar",
      "activate": "Activar",
      "deactivate": "Desactivar"
    },
    "fields": {
      "id": "ID",
      "registrationNumber": "Número de Registro",
      "vendorType": "Tipo de Proveedor",
      "username": "Nombre de Usuario",
      "establishedYear": "Año de Establecimiento",
      "email": "Correo Electrónico",
      "location": "Ubicación",
      "phoneNumber": "Número de Teléfono",
      "emergencyNumber": "Número de Emergencia",
      "website": "Sitio Web",
      "plan": "Plan de Suscripción"
    },
    "messages": {
      "approvedSuccessfully": "Aprobado Exitosamente",
      "deletedSuccessfully": "Eliminado Exitosamente",
      "activatedSuccessfully": "Activado Exitosamente",
      "deactivatedSuccessfully": "Desactivado Exitosamente",
      "cannotDeleteDueToUnpaidBills": "El proveedor no puede ser eliminado porque hay facturas impagas",
      "rejectedSuccessfully": "Proveedor de Servicios rechazado exitosamente",
      "failedToSubmit": "Error al enviar datos",
      "failedToReject": "Error al rechazar",
      "errorSubmission": "Error en el envío de datos. ¡Por favor intente nuevamente!",
      "errorInData": "Error en los Datos",
      "providerDeleted": "Este Proveedor Está Eliminado"
    },
    "confirmations": {
      "delete": "¿Está seguro de que desea eliminar este proveedor?",
      "activate": "¿Está seguro de que desea activar este proveedor?",
      "deactivate": "¿Está seguro de que desea desactivar este proveedor?",
      "areYouSure": "¿Está seguro?"
    },
    "id": "Proveedor ID",
    "username": "Nombre de usuario",
    "registrationNumber": "Número de Registro",
    "healthCareType": "Tipo de Atención Médica",
    "vendorType": "Tipo de Proveedor",
    "establishedYear": "Año de Establecimiento",
    "email": "Correo Electrónico",
    "location": "Ubicación",
    "phoneNumber": "Número de Teléfono",
    "emergencyNumber": "Número de Emergencia",
    "deliveryRadius": "Radio de Entrega (km)",
    "website": "Sitio Web",
    "reject": "Rechazar",
    "approve": "Aprobar",
    "delete": "Eliminar",
    "deactivate": "Desactivar",
    "activate": "Activar",
    "areYouSure": "¿Estás seguro de rechazar este proveedor de servicios?",
    "approvedSuccessfully": "Aprobado exitosamente",
    "serviceProviderRejected": "Proveedor de Servicios rechazado exitosamente",
    "failedToSubmit": "Error al enviar datos",
    "failedToReject": "Error al rechazar",
    "errorInData": "Error en la recuperación de datos. ¡Por favor, intente nuevamente!",
    "deleteConfirmation": "¿Está seguro de eliminar este Proveedor de Servicios?",
    "activateConfirmation": "¿Está seguro de activar este Proveedor de Servicios?",
    "deactivateConfirmation": "¿Está seguro de desactivar este Proveedor de Servicios?",
    "deletedSuccessfully": "Eliminado exitosamente",
    "activatedSuccessfully": "Activado exitosamente",
    "deactivatedSuccessfully": "Desactivado exitosamente",
    "clinics": "Proveedores",
    "home": "Inicio",
    "bankingInfo": "Información Bancaria",
    "reports": "Reportes",
    "notAvailable": "No disponible",
    "thisProviderIsDeleted": "Este proveedor de servicios está eliminado"
  },
  "bankingInfo": {
    "loading": "Cargando...",
    "notProvided": "No Proporcionado",
    "accountNumber": "Número de Cuenta / IBAN",
    "swiftCode": "Código SWIFT/BIC",
    "branchAddress": "Dirección de la Sucursal",
    "paymentMethod": "Método de pago",
    "currency": "Moneda",
    "proofDocument": "Documento de Prueba",
    "subscriptionPlan": "Plan de Suscripción",
    "noBankInfo": "No se encontró información bancaria",
    "cash": "Efectivo",
    "bank": "Banco",
    "basic": "Básico",
    "free": "Plan Gratis",
    "monthly": "Mensual",
    "yearly": "Anual",
    "title": "Información Bancaria",
    "accountHolder": "Titular de la Cuenta",
    "bankName": "Nombre del Banco",
    "errorLoading": "Error al cargar la información bancaria",
    "close": "Cerrar",
    "zoomIn": "Acercar",
    "zoomOut": "Alejar",
    "resetZoom": "Restablecer Zoom",
    "cannotPreviewFile": "No se puede previsualizar este tipo de archivo",
    "clickToPreview": "Haga clic para previsualizar {{type}}: {{name}}",
    "standard": "Estándar",
    "premium": "Premium",
    "failedToLoadPDF": "No se pudo cargar el PDF",
  },
  "professionals": {
    "general_practitioners": "Médicos Generales",
    "therapists": "Terapeutas"
  },
  "paymentMethods": {
    "cash": "Efectivo",
    "bank": "Banco",
    "card": "Tarjeta",
    "cod": "Contra reembolso",
    "benefit_pay": "Pago de beneficios",
    "upi": "UPI"
  },
  "currencies": {
    "eur": "Euro",
    "inr": "Rupia india",
    "usd": "Dólar estadounidense",
    "crc": "Colón costarricense"
  },
  "professionalsList": {
    "Hospital": "Hospital",
    "Clinic": "Clínica",
    "Laboratory": "Laboratorio",
    "Pharmacy": "Farmacia",
    "Diagnostic": "Centro de Diagnóstico",
    "Single Doctor": "Médico individual",
    "Single Nurse": "Enfermera individual",
    "General Practitioners": "Médicos Generales",
    "Therapists": "Terapeutas",
    "Neurodevelopmental Specialists": "Especialistas en Neurodesarrollo",
    "Specialist Doctors": "Médicos Especialistas",
    "Dentists": "Dentistas",
    "Odontologists": "Odontólogos",
    "Nurses": "Enfermeros/Enfermeras",
    "Patient Assistants": "Asistentes de Paciente",
    "Psychologists": "Psicólogos",
    "Nutritionists": "Nutricionistas",
    "Physiotherapists": "Fisioterapeutas",
    "Respiratory Therapists": "Terapeutas Respiratorios",
    "Electrocardiography": "Electrocardiografía",
    "Speech Therapists": "Terapeutas de Lenguaje"
  },
  "otpVerification": {
    "title": "Verifique sus datos",
    "completeVerification": "Completar verificación",
    "bothMustVerify": "Tanto el correo electrónico como el teléfono deben verificarse antes de continuar",
    "emailVerification": "Verificación de correo electrónico",
    "phoneVerification": "Verificación de teléfono",
    "verified": "Verificado",
    "verifyEmail": "Verificar correo",
    "verifyPhone": "Verificar teléfono",
    "enterOTP": "Ingrese OTP",
    "resendOTP": "Reenviar OTP",
    "sending": "Enviando...",
    "verifying": "Verificando...",
    "submit": "Enviar",
    "cancel": "Cancelar",
    "proceedRegistration": "Continuar con el registro",
    "email": "Correo",
    "phone": "Teléfono",
    "complete": "Completar",
    "successMessages": {
      "email": "Correo electrónico verificado con éxito",
      "phone": "Teléfono verificado con éxito",
      "otpSent": "OTP enviado a su {{method}}"
    },
    "errorMessages": {
      "invalidOTP": "OTP inválido. Por favor intente nuevamente.",
      "verificationFailed": "Error en la verificación. Por favor intente nuevamente.",
      "sendFailed": "Error al enviar OTP. ¡Intente nuevamente!",
      "enterOTP": "Por favor ingrese OTP",
      "verifyBoth": "Por favor verifique tanto el correo como el teléfono antes de continuar"
    }
  },
  "serviceCatalogue": {
    "id": "ID del Proveedor",
    "searchByService": "Buscar por Servicio o Descripción",
    "searchByProduct": "Buscar por Producto",
    "searchByVendorId": "Buscar por ID de Proveedor",
    "searchByVendorName": "Buscar por Nombre de Proveedor",
    "services": "Servicios",
    "createdAt": "Creado el",
    "vendor": "Proveedores",
    "duration": "Duración",
    "fee": "Tarifa",
    "serviceMode": "Modo de Servicio",
    "home": "Casa",
    "lab": "Clínica",
    "category": "Categoría",
    "subcategory": "Subcategoría",
    "description": "Descripción",
    "shortDescription": "Descripción Corta",
    "loading": "Cargando..."
  },
  "revenue": {
    "title": "Análisis de Ingresos",
    "summaryTitle": "Resumen de Ingresos",
    "totalRevenue": "Ingresos Totales",
    "totalTransactions": "Transacciones Totales",
    "activeVendors": "Proveedores Activos",
    "averageRevenue": "Ingreso Promedio",
    "searchByVendorName": "Buscar por Nombre del Proveedor",
    "searchByVendorId": "Buscar por ID del Proveedor",
    "searchVendorsPlaceholder": "Buscar proveedores por ID o nombre...",
    "fromDate": "Desde Fecha",
    "toDate": "Hasta Fecha",
    "export": "Exportar",
    "exportCSV": "Exportar CSV",
    "exportPDF": "Exportar PDF",
    "pieTitle": "Ingreso Total Generado",
    "pieCenterTotal": "Total",
    "dataTitle": "Datos de Ingresos",
    "allStatus": "Todos los Estados",
    "allTypes": "Todos los Tipos",
    "id": "ID",
    "vendorName": "Nombre del Proveedor",
    "vendorType": "Tipo de Proveedor",
    "transactions": "Transacciones",
    "lastTransaction": "Última Transacción",
    "actions": "Acciones",
    "viewDetails": "Ver Detalles",
    "noData": "No se encontraron datos de ingresos",
    "loading": "Cargando...",
    "detailsTitle": "Detalles de Ingresos",
    "vendorId": "ID del Proveedor",
    "period": "Período",
    "timePeriod": "Período de Tiempo",
    "allTime": "Todo el Tiempo",
    "today": "Hoy",
    "thisWeek": "Esta Semana",
    "thisMonth": "Este Mes",
    "thisYear": "Este Año",
    "customRange": "Rango Personalizado",
    "allVendors": "Todos los Proveedores",
    "vendorTypeMenu": "Tipo de Proveedor",
    "commissionDeducted": "Comisión Deducida",
    "pendingAmount": "Monto Pendiente",
    "vendorTypes": {
      "Hospital": "Hospital",
      "Clinic": "Clínica",
      "Laboratory": "Laboratorio",
      "Pharmacy": "Farmacia",
      "Diagnostic Center": "Centro de Diagnóstico",
      "Therapists": "Terapeutas",
      "Neurodevelopmental Specialists": "Especialistas en Neurodesarrollo",
      "Dentists": "Dentistas",
      "Odontologists": "Odontólogos",
      "Patient Assistants": "Asistentes de Pacientes",
      "Psychologists": "Psicólogos",
      "Nutritionists": "Nutricionistas",
      "Physiotherapists": "Fisioterapeutas",
      "Respiratory Therapists": "Terapeutas Respiratorios",
      "Electrocardiography": "Electrocardiografía",
      "Speech Therapists": "Terapeutas del Habla",
      "Single Doctor": "Médico Individual",
      "Single Nurse": "Enfermera Individual"
    },
    "searchVendorNamePlaceholder": "Buscar por nombre del proveedor...",
    "searchVendorIdPlaceholder": "Buscar por ID del proveedor...",
    "totalOrders": "Órdenes Totales",
    "commissionReceived": "Comisión Recibida",
    "headers": {
      "hospitalId": "ID del Proveedor",
      "vendorName": "Nombre del Proveedor",
      "totalOrders": "Órdenes Totales",
      "revenue": "Ingresos",
      "commissionAmountPercent": "Monto/Porcentaje de Comisión",
      "netPayout": "Pago Neto",
      "commissionAmount": "Monto de Comisión",
      "commissionPercent": "Porcentaje de Comisión",
      "status": "Estado",
      "type": "Tipo",
      "subscription": "Suscripción",
      "period": "Período"
    }
  },
  "vendorDetails": {
    "noOrders": "No hay órdenes presentes para el período seleccionado",
    "filters": {
      "all": "Todas las Órdenes",
      "products": "Solo Productos",
      "services": "Solo Servicios",
      "fromDate": "Desde Fecha",
      "toDate": "Hasta Fecha",
      "export": "Exportar",
      "exportCSV": "Exportar como CSV",
      "exportPDF": "Exportar como PDF"
    },
    "headers": {
      "itemName": "Nombre del Artículo",
      "category": "Categoría",
      "quantity": "Cantidad",
      "totalRevenue": "Ingreso Total",
      "orderId": "ID de Orden",
      "invoice": "Factura",
      "date": "Fecha"
    },
    "back": "Atrás",
    "viewInvoice": "Ver Factura",
    "loading": "Cargando...",
    "noItems": "No se encontraron artículos"
  },
  "liability": {
    "title": "Pasivos",
    "loading": "Cargando...",
    "failedToLoad": "No se pudieron cargar los pasivos",
    "noLiabilities": "No se encontraron pasivos.",
    "table": {
      "id": "ID",
      "item": "Artículo",
      "request": "Solicitud",
      "paidAmount": "Monto pagado",
      "totalAmount": "Monto total",
      "liability": "Pasivo"
    },
    "invoiceButton": "Factura",
    "invoice": "Factura",
    "openInvoice": "Abrir factura",
    "noDownload": "No hay factura disponible para descargar.",
    "email": "Correo electrónico"
  },
  "invoice": {
    "title": "Factura",
    "invoiceTitle": "FACTURA",
    "loading": {
      "loadingInvoice": "Cargando factura..."
    },
    "alerts": {
      "paymentRecorded": "¡Pago registrado exitosamente!",
      "failedToSave": "Error al guardar el pago. Por favor, inténtelo de nuevo.",
      "enterTransactionRef": "Por favor ingrese el número de referencia de transacción",
      "identificationNotUpdated": "El número de identificación no está actualizado, por lo que no se puede proceder con el pago",
      "leadingSpacesNotAllowed": "No se permiten espacios al principio"
    },
    "buttons": {
      "print": "Imprimir",
      "saveAndPay": "Guardar y Pagar",
      "saving": "Guardando..."
    },
    "labels": {
      "date": "Fecha",
      "itemService": "Artículo/Servicio",
      "issuedDate": "Fecha de Emisión",
      "total": "Total",
      "payable": "Por Pagar",
      "transactionRef": "Número de Referencia de Transacción *",
      "remarks": "Observaciones"
    },
    "placeholders": {
      "transactionRef": "Ingrese el número de referencia de transacción",
      "remarks": "Ingrese observaciones adicionales"
    },
    "defaults": {
      "license": "Licencia"
    },
    "notes": {
      "printWarning": "** En caso de que 'Imprimir' no funcione, verifique que el bloqueador de ventanas emergentes esté 'desactivado' en la configuración de su navegador.",
      "priceIncludesTax": "** El precio incluye todos los impuestos aplicables"
    }
  },
  "productCatalogue": {
    "headers": {
      "productName": "Nombre del producto",
      "catalogueId": "ID de catálogo",
      "quantityInStock": "Cantidad en stock",
      "vendor": "Proveedores",
      "vendorId": "ID del proveedor",
      "createdAt": "Creado el"
    }
  },
  "liabilities": {
    "loginAlegra": "Parece que su sesión de inicio de sesión no es válida. Por favor, cierre sesión y vuelva a iniciar sesión.",
    "loading": "Cargando...",
    "title": "Pasivos de Proveedores",
    // "all": "Todos los Pasivos",
    "all": "Pasivos",
    "paid": "Pagados",
    "searchByName": "Buscar por nombre",
    "searchHospitalID": "Buscar por ID",
    "hospitalID": "ID del Hospital",
    "hospitalName": "Nombre del Hospital",
    "billType": "Tipo de Factura",
    "liability": "Responsabilidad",
    "billDate": "Fecha de Factura",
    "renewalDate": "Fecha de Renovación",
    "status": "Estado",
    "noLiabilities": "No se encontraron responsabilidades",
    "noPaidLiabilities": "No se encontraron responsabilidades pagadas",
    "id": "ID",
    "invoice": "Factura",
    "noInvoiceImage": "No hay imagen de factura disponible",
    "itemName": "Concepto",
    "billDate": "Fecha de Factura",
    "renewalDate": "Fecha de Renovación",
    "vendor": "Proveedor",
    "billType": "Tipo de Factura",
    "paidAmount": "Monto Pagado",
    "searchID": "Buscar por ID",
    "statusValues": {
      "paid": "Pagado",
      "not_paid": "Pendiente"
    }
  },
  "vendorRev": {
    "vendorId": "Proveedor {{id}}",
    "invalidDate": "Fecha Inválida",
    "orderNumber": "Número de Orden",
    "name": "Nombre",
    "catalogueType": "Tipo de Catálogo",
    "date": "Fecha",
    "product": "Producto",
    "service": "Servicio",
    "orderDetails": "Detalles de Orden",
    "hospitalId": "ID del Hospital",
    "invoice": "Factura",
    "loading": "Cargando...",
    "noOrders": "No se encontraron órdenes",
    "noInvoice": "No hay factura disponible",
    "back": "Atrás",
    "filters": {
      "all": "Todos",
      "products": "Productos",
      "services": "Servicios",
      "export": "Exportar",
      "exportCSV": "Exportar CSV",
      "exportPDF": "Exportar PDF",
      "fromDate": "Desde Fecha",
      "toDate": "Hasta Fecha"
    }
  }
};
export default translation;